'use client';

import { usePathname } from 'next/navigation';
import { Suspense } from 'react';
import PublicAuthProvider from 'src/app/_components/Providers/PublicAuthProvider';
import { RECEIPT_BOTTOM_BAR_HEIGHT } from 'src/app/(seoleimrun)/seoleimrun/receipt/_components/constants';
import { cn } from 'src/app/lib/utils/tailwindcss';

import Footer from '@/app/_components/Footer';

import Header from './Header/Header';

interface ClientLayoutProps {
  children: React.ReactNode;
}

export function ClientLayout({ children }: ClientLayoutProps) {
  const pathname = usePathname();
  // 하단 고정(fixed) 버튼 바가 있는 페이지는 Footer/콘텐츠가 가려지지 않도록 바 높이만큼 예약. (참고: doosanbears ClientLayout)
  const isReceiptPage = pathname === '/seoleimrun/receipt';
  const isGiftPage = pathname === '/seoleimrun/gift';
  // MY 내역 중 하단 고정 CTA 가 있는 페이지만 (선물/영수증). 경품당첨 내역은 CTA 없음.
  const isMyGiftPage = pathname === '/seoleimrun/my/gift';
  const isMyReceiptPage = pathname === '/seoleimrun/my/receipt';
  const hasBottomBar = isReceiptPage || isGiftPage || isMyGiftPage || isMyReceiptPage;

  return (
    <Suspense fallback={null}>
      <PublicAuthProvider>
        <div className="scrollbar-hidden h-full w-full bg-[#0d0a17]">
          <div
            className={cn(
              'relative z-0 mx-auto flex min-h-dvh w-full max-w-[480px] flex-1 flex-col items-center overflow-hidden bg-g-00',
              'before:fixed before:top-0 before:left-1/2 before:z-9999 before:hidden before:h-full before:w-px before:-translate-x-[240px] before:bg-g-70 before:content-[""]',
              'after:fixed after:top-0 after:right-1/2 after:z-9999 after:hidden after:h-full after:w-px after:translate-x-[240px] after:bg-g-70 after:content-[""]',
              'mobile:before:block mobile:after:block',
            )}
            style={hasBottomBar ? { paddingBottom: RECEIPT_BOTTOM_BAR_HEIGHT } : undefined}
          >
            <Header />
            <main className="flex min-h-full w-full flex-1 flex-col overflow-x-clip" role="main">
              {children}
            </main>
            <Footer />
          </div>
        </div>
      </PublicAuthProvider>
    </Suspense>
  );
}
